import React from 'react'
import useTrans from '../../../hooks/useTrans'
import FormField from '../../atoms/FormField/FormField'
import FormTextarea, { ENTER } from '../../atoms/FormTextarea/FormTextarea'

const ModalContentNota = ({ setNota, nota }) => {
  const t = useTrans()
  return (
    <div className="cart-note-modal__content">
      <FormField label={t("Note sull'articolo")}>
        <FormTextarea
          placeholder={t("Inserisci informazioni relative all'articolo")}
          value={nota}
          onChange={(e) => setNota(e.target.value)}
          preventKeys={[ENTER]}
          className="textarea_modal_input"
          maxLength={70}
        />
      </FormField>
    </div>
  )
}

export default ModalContentNota
